import React, {Fragment, useRef, useState} from "react";
import {
  ButtonIcon,
  isProfileRoleTypeTags,
  Loading,
  Search,
  TextSearchMarker,
  useList,
  useProfile,
  useUnroll,
} from "@vokymlak/kabinet-ui";
import {ScrollBlock} from "../../../../components/ScrollBlock/ScrollBlock";
import {ROOT_URL} from "../../../../config/url";
import ModalRealizationBranchAdd from "./ModalRealizationBranchAdd";
import ModalRealizationBranchEdit from "./ModalRealizationBranchEdit";
import {ROLE_ADMINISTRATOR, ROLE_DIRECTOR, ROLE_EMPLOYEE} from "../../../../config/constants";

function RealizationBranchesPage(props) {
  const {
    setBranch,
    setIsSelectBranch,
  } = props;

  const {profile} = useProfile();

  const inputSearchText = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");

  const {
    list: [list, count, setList],
    update: [isUpdateList, setIsUpdateList, updateList],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    params: [_listParams, setListParams],
  } = useList({
    apiUrl: "/api/realization-branches",
    rootUrl: ROOT_URL,
    isPagination: true,
    paginationLimit: 10,
  });

  const onChangeSearchText = () => {
    setSearchQuery(inputSearchText.current.value.trim());
  };

  const changePage = (data) => {
    if (pageNumber !== data.currentPage) {
      setPageNumber(data.currentPage);
    }
  };

  const {unrolls, isUnroll, changeUnroll, changeAllUnroll} = useUnroll();


  const [isModalObjectAdd, setIsModalObjectAdd] = useState(false);
  const [modalObjectEdit, setModalObjectEdit] = useState(null);

  return (
    <ScrollBlock style={{width: "100%", height: "100%"}}>
      <div className="Page">
        <div className="Page__title">
          <div
            className="Title__text"
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 21,
              fontWeight: 700,
            }}
          >
            <div
              className="Title__text"
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                fontSize: 19,
                fontWeight: 700,
              }}
            >
              <div>
                Выбор филиала

                {!!list && (
                  <span style={{fontSize: 12, opacity: 0.75, marginLeft: 6}}>
                    ({count})
                  </span>
                )}
              </div>
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 400,
                }}
              >
                Реализация
              </span>
            </div>
            <span style={{width: 140, marginLeft: 16}}>
              <Search
                reference={inputSearchText}
                type="text"
                label={"Поиск"}
                isFixed={true}
                onChange={() => onChangeSearchText()}
              />
            </span>
          </div>

          <div className="Title__settings">
            <ButtonIcon
              tooltipText={"Обновить"}
              iconName={"custom-change-circle"}
              iconColor={"#20202075"}
              size={28}
              style={{marginLeft: 8}}
              onClick={() => (setList(null), setIsUpdateList(!isUpdateList))}
            />

            {isProfileRoleTypeTags(profile, [
              ROLE_ADMINISTRATOR,
              ROLE_DIRECTOR,
            ]) && (
              <ButtonIcon
                tooltipText={"Добавить"}
                iconName={"custom-add"}
                iconColor={"#0064ff"}
                size={36}
                style={{marginLeft: 12}}
                onClick={() => setIsModalObjectAdd(true)}
              />
            )}
          </div>
        </div>

        {!list && (
          <div className={"Page__loader"}>
            <Loading/>
          </div>
        )}

        {!!list && (
          <div className="Page__content">
            <ul className="List">
              {list.map((item) => (
                <Fragment key={"item_" + item.uuid}>
                  <li
                    className={
                      isUnroll(item.uuid) ? "List__item active" : "List__item"
                    }
                    onClick={
                      isProfileRoleTypeTags(profile, [
                        ROLE_EMPLOYEE,
                      ])
                        ? () => (setBranch(item.branch), setIsSelectBranch(true))
                        : () => changeUnroll(item.uuid)
                    }
                    style={{
                      padding: "10px 12px",
                      position: "relative",
                    }}
                  >
                    <div
                      className="Item__title"
                      style={{
                        width: "100%",
                      }}
                    >
                      <div
                        className="Element__title"
                        style={{
                          width: "100%",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 19,
                            fontWeight: 700,
                            width: "100%",
                          }}
                        >
                          {!!item.branch && !!item.branch.short_name && (
                            <TextSearchMarker
                              text={item.branch.short_name}
                              search={searchQuery}
                            />)}
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            {!!item.branch && !!item.branch.name && (
                              <TextSearchMarker
                                text={item.branch.name}
                                search={searchQuery}
                              />)}
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span style={{marginRight: 8}}>ОГРН:&nbsp;{(!!item.branch && !!item.branch.ogrn && (
                              <TextSearchMarker
                                text={item.branch.ogrn}
                                search={searchQuery}
                              />)) || "-"}</span>
                            <span style={{marginRight: 8}}>ИНН:&nbsp;{(!!item.branch && !!item.branch.inn && (
                              <TextSearchMarker
                                text={item.branch.inn}
                                search={searchQuery}
                              />)) || "-"}</span>
                            <span style={{marginRight: 8}}>КПП:&nbsp;{(!!item.branch && !!item.branch.kpp && (
                              <TextSearchMarker
                                text={item.branch.kpp}
                                search={searchQuery}
                              />)) || "-"}</span>
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span
                              style={{marginRight: 8}}>Банк:&nbsp;{(!!item.branch && !!item.branch.bank && item.branch.bank) || "-"}</span>
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span
                              style={{marginRight: 8}}>Номер&nbsp;счёта:&nbsp;{(!!item.branch && !!item.branch.invoice_number && (
                              <TextSearchMarker
                                text={item.branch.invoice_number}
                                search={searchQuery}
                              />)) || "-"}</span>
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span style={{marginRight: 8}}>Полное&nbsp;ФИО&nbsp;директора:&nbsp;
                              {(!!item.branch && !!item.branch.director_full_name && (item.branch.director_full_name)) || "-"}
                            </span>
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span style={{marginRight: 8}}>Фамилия&nbsp;и&nbsp;инициалы&nbsp;директора:&nbsp;
                              {(!!item.branch && !!item.branch.director_short_name && (item.branch.director_short_name)) || "-"}
                            </span>
                          </div>
                          <div style={{
                            fontSize: 12,
                            fontWeight: 400,
                          }}>
                            <span style={{marginRight: 8}}>Телефон:&nbsp;
                              {(!!item.branch && !!item.branch.phone && (item.branch.phone)) || "-"}
                            </span>
                            <span style={{marginRight: 8}}>Емайл:&nbsp;
                              {(!!item.branch && !!item.branch.email && (item.branch.email)) || "-"}
                            </span>
                            <span style={{marginRight: 8}}>Сайт:&nbsp;
                              {(!!item.branch && !!item.branch.site && (item.branch.site)) || "-"}
                            </span>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "absolute",
                            top: -8,
                            left: 0,
                            justifyContent: " flex-end",
                            width: "100%",
                            padding: "0 8px",
                          }}
                        >
                          {!!item.branch && item.branch.is_main && (
                            <div
                              style={{
                                fontSize: 11,
                                fontWeight: 700,
                                backgroundColor: "#202020",
                                display: "inline-block",
                                color: "white",
                                padding: "2px 4px 2px",
                                borderRadius: 3,
                                margin: "0 2px",
                              }}
                            >
                              Основной
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="Item__settings">
                      <div className="Element__datetime">
                      </div>
                    </div>
                  </li>

                  {isUnroll(item.uuid) && (
                    <li className="List__content">
                      <div className="Content__header">
                        <div className="Header__title">
                          <div
                            className="Button__text Button__text_right"
                            onClick={() => (setBranch(item.branch), setIsSelectBranch(true))}
                          >
                            Перейти в реализацию
                          </div>
                        </div>
                        <div className="Header__settings">
                          {isProfileRoleTypeTags(profile, [
                            ROLE_ADMINISTRATOR,
                            ROLE_DIRECTOR,
                          ]) && (
                            <ButtonIcon
                              tooltipText={"Редактировать"}
                              iconName={"custom-edit"}
                              iconColor={"#202020"}
                              size={36}
                              style={{marginLeft: 12}}
                              onClick={() => setModalObjectEdit(item)}
                            />
                          )}
                        </div>
                      </div>
                    </li>
                  )}
                </Fragment>
              ))}
            </ul>
          </div>
        )}

        {!!modalObjectEdit && (
          <ModalRealizationBranchEdit
            object={modalObjectEdit}
            successfulRequest={() => setIsUpdateList(!isUpdateList)}
            handleClose={() => setModalObjectEdit(null)}
          />
        )}
        {!!isModalObjectAdd && (
          <ModalRealizationBranchAdd
            successfulRequest={() => setIsUpdateList(!isUpdateList)}
            handleClose={() => setIsModalObjectAdd(false)}
          />
        )}
      </div>
    </ScrollBlock>
  );
}

export default RealizationBranchesPage;
